import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import 'font-awesome/scss/font-awesome.scss';
import VueScrollTo from 'vue-scrollto';

import App from './App';
import router from './router';
import store from './store';

window.NODE_ENV = process.env.NODE_ENV;

Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper);
Vue.use(VueScrollTo);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App />',
  data() {
    return {
      modals: {
        confirm: undefined,
        alert: undefined,
        maintenance: undefined,
      },
    };
  },
  methods: {
    confirm(message) {
      return new Promise((resolve, reject) => {
        this.modals.confirm = {
          active: true,
          message,
          resolve,
          reject,
        };
      });
    },
    alert(message, title = '') {
      return new Promise((resolve, reject) => {
        this.modals.alert = {
          active: true,
          message,
          title,
          resolve,
          reject,
        };
      });
    },
    maintenance() {
      return new Promise((resolve, reject) => {
        this.modals.maintenance = {
          active: true,
          resolve,
          reject,
        };
      });
    },
  },
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js